import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSocialLoginContext } from "../context";
import { useUserContext } from "@magento/peregrine/lib/context/user";
import { env } from "build/env";
const VISIBLE_BUTTONS_COUNT = 3;
const getPopupParams = () => {
  const bottomPadding = 22;
  const screenX = window.screenX || window.screenLeft;
  const screenY = window.screenY || window.screenTop;
  const outerWidth = window.outerWidth || document.body.clientWidth;
  const outerHeight = window.outerHeight || document.body.clientHeight - bottomPadding;
  const width = 500;
  const height = 420;
  const leftDivider = 2;
  const topDivider = 2.5;
  const left = parseInt(screenX + (outerWidth - width) / leftDivider, 10);
  const top = parseInt(screenY + (outerHeight - height) / topDivider, 10);
  return "width=".concat(width, ",height=").concat(height, ",left=").concat(left, ",top=").concat(top);
};
export const useSocButtons = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    buttons,
    mode,
    showCreateAccount
  } = props;
  const isShowMoreBtn = mode === "popup" && buttons.length > VISIBLE_BUTTONS_COUNT;
  const [showAll, setShowAll] = useState(!isShowMoreBtn);
  const {
    buttonShape,
    errors,
    handleErrors
  } = useSocialLoginContext();
  const [{
    isSignedIn,
    token
  }] = useUserContext();
  const errorRef = useRef(null);
  const storeCode = env.store_view_code;
  const visibleButtons = useMemo(() => showAll ? buttons : buttons.slice(0, VISIBLE_BUTTONS_COUNT), [showAll, buttons]);
  const handleLogin = useCallback(button => {
    const {
      type,
      url
    } = button;
    handleErrors(null);
    window.open("".concat(url, "&isAjax=true&store=").concat(storeCode).concat(!isSignedIn ? "&generateToken=true" : "&token=".concat(token)), type, getPopupParams());
  }, [isSignedIn, handleErrors, token]);
  const handleShowMore = useCallback(() => setShowAll(true), [setShowAll]);
  useEffect(() => {
    const el = errorRef && errorRef.current;
    if (errors) {
      const {
        redirectWithError
      } = errors;
      if (redirectWithError && showCreateAccount && typeof showCreateAccount === "function") {
        handleErrors(_objectSpread(_objectSpread({}, errors), {}, {
          redirectWithError: 0
        }));
        showCreateAccount();
      }
      if (el && mode === "popup") {
        el.scrollIntoView();
      }
    }
    return () => {
      if (errors && !errors.redirectWithError) {
        handleErrors(null);
      }
    };
  }, [errors, errorRef, showCreateAccount, handleErrors, mode]);
  return {
    handleLogin,
    visibleButtons,
    isShowMoreBtn: isShowMoreBtn && !showAll,
    handleShowMore,
    buttonShape,
    errors,
    errorRef
  };
};